<section class="margin-test">
  <div class="vendor-row">
    <label class="vendor-picker">
      <span>Vendor</span>
      <div class="vendor-name">{{ vendorName || 'This vendor' }}</div>
    </label>
    <p>Use a representative frame to test a proposed rule for this vendor.</p>
  </div>

  <div class="input-row">
    <label>
      <span>Invoice currency</span>
      <select [value]="currency" (change)="onCurrencyChange($any($event.target).value)">
        <option *ngFor="let code of currencies" [value]="code">{{ code }} · {{ symbolFor(code) }}</option>
      </select>
    </label>
    <label>
      <span>Frame cost — {{ symbol }}</span>
      <input type="number" min="0" step="0.01" [value]="foreignCost" (change)="foreignCost = num($any($event.target).value)">
    </label>
    <label>
      <span>Live USD rate · 1 {{ currency }} = $</span>
      <input type="text" [value]="rateLabel" readonly tabindex="-1">
    </label>
    <label>
      <span>Shipping — {{ symbol }}</span>
      <input type="number" min="0" step="0.01" [value]="shipping" (change)="shipping = num($any($event.target).value)">
    </label>
    <label>
      <span>Tax / duty — {{ symbol }}</span>
      <input type="number" min="0" step="0.01" [value]="duty" (change)="duty = num($any($event.target).value)">
    </label>
  </div>

  <div class="formula">
    <div>
      <b>Converted frame cost</b>
      <strong>{{ convertedCost | currency }}</strong>
    </div>
    <span class="op">+</span>
    <div>
      <b>Shipping</b>
      <strong>{{ convertedShipping | currency }}</strong>
    </div>
    <span class="op">+</span>
    <div>
      <b>Tax / duty</b>
      <strong>{{ convertedDuty | currency }}</strong>
    </div>
    <span class="op">=</span>
    <div>
      <b>Landed cost — USD</b>
      <strong>{{ landed | currency }}</strong>
    </div>
  </div>

  <div class="slider-row">
    <div class="control-group">
      <label class="slider-field">
        <span>Test cost multiple</span>
        <input type="range" min="1.5" max="10" step="0.1"
          [value]="sliderMultiple"
          [style.accent-color]="signalColor"
          (input)="setMultiple($any($event.target).value)">
      </label>
      <label>
        <span>Multiple</span>
        <input type="number" min="1.5" max="10" step="0.1" [value]="multiple | number:'1.1-1'" (change)="setMultiple($any($event.target).value)">
      </label>
    </div>
    <div class="control-group">
      <label class="slider-field">
        <span>Or test target margin</span>
        <input type="range" min="40" max="90" step="0.5"
          [value]="sliderMargin"
          [style.accent-color]="signalColor"
          (input)="setMargin($any($event.target).value)">
      </label>
      <label>
        <span>Margin %</span>
        <input type="number" min="1" max="90" step="0.1" [value]="marginPercent | number:'1.1-1'" (change)="setMargin($any($event.target).value)">
      </label>
    </div>
  </div>

  <div class="signal" [class.red]="signal === 'red'" [class.yellow]="signal === 'yellow'" [class.green]="signal === 'green'">
    <div>
      <strong>{{ signalLabel }}</strong>
      <small>Provisional example: floor 60% · target 66.7%. Admin chooses the final thresholds.</small>
    </div>
    <span class="signal-state">{{ signalState }}</span>
  </div>

  <div class="result-row">
    <div>
      <b>Landed cost — USD</b>
      <strong class="money">{{ landed | currency }}</strong>
    </div>
    <span class="arrow">→</span>
    <label class="retail">
      <span>Proposed retail price — editable</span>
      <input type="number" min="0" step="1" [value]="proposedRetail | number:'1.2-2'" (change)="setRetail($any($event.target).value)">
    </label>
    <div class="gross" [class.red]="signal === 'red'" [class.yellow]="signal === 'yellow'" [class.green]="signal === 'green'">
      <b>Gross margin</b>
      <strong>{{ marginPercent | number:'1.1-1' }}%</strong>
      <small>{{ multiple | number:'1.2-2' }}× landed cost</small>
    </div>
  </div>

  <div class="results-wrap">
  <table class="results" id="vendor-margin-results">
    <thead>
      <tr>
        <th>Scenario</th>
        <th>Landed cost</th>
        <th>Proposed retail</th>
        <th>Gross profit</th>
        <th>Gross margin</th>
        <th>Cost multiple</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Test</td>
        <td>{{ landed | currency }}</td>
        <td>{{ proposedRetail | currency }}</td>
        <td>{{ grossProfit | currency }}</td>
        <td>{{ marginPercent | number:'1.1-1' }}%</td>
        <td>{{ multiple | number:'1.2-2' }}×</td>
      </tr>
    </tbody>
  </table>
  </div>

  <div class="footer">
    <p>This test does not change past sales or existing frame prices. Approval sets the default pricing rule for new frames received from this vendor.</p>
    <div class="actions">
      <button type="button" class="draft">Save as Draft</button>
      <button type="button" class="approve">Approve Vendor Rule</button>
    </div>
  </div>
</section>
